export default {
    USER_ID: 'user_3JW8ef3hfmjiQP3dO8Y7e',
    TEMPLATE_ID: 'template_mfpmrx6'
    }